export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_08-c67ff9bec1ef463d5bceddf8689155ce.jpg";